import makeRequest from ".";

export function createLesson(lesson_id, requestBody) {
  return makeRequest({
    uri: `/v1/lessons/${lesson_id}/users_lesson`,
    method: "POST",
    body: JSON.stringify(requestBody),
  });
}
